import {css} from 'lit'; export default css`:host{--fly-modal-min-width:700px}.downloader-modal__fields{margin-bottom:24px}.downloader-modal__fields__label{font-size:.875rem;font-style:normal;color:#7f7a93;margin-bottom:6px}`;
    